import {DlRadioSelectOption} from '@wallaby-ui/core';
import * as React from 'react';
import {Form} from 'react-bootstrap';

import FilterNodeItemLabel from './FilterNodeItemLabel';
import styles from './FilterNodeTypeRadioItem.less';
import {
  DynamicFilter,
  Filter,
  FILTER_TYPE_RADIO_ENUM,
} from 'src/js/lib/filtering';
import {FilterNode as FilterNodeModel} from 'src/js/model/filters_config';

interface OwnProps {
  inputRef?: (inputElement: HTMLInputElement) => void;
  isOpened?: boolean;
  node: FilterNodeModel;
  changeFilter: (values: any) => void;
  selectedFilter?: Filter;
  value: DlRadioSelectOption<string | number>;
}
type Props = OwnProps;

export const FilterNodeTypeRadioItem: React.FC<Props> = (props) => {
  const {inputRef, isOpened = false, node, value, changeFilter} = props;

  const getFilter = () => {
    const SelectFilter = DynamicFilter.getFilterClass(FILTER_TYPE_RADIO_ENUM);
    return new SelectFilter({
      type: FILTER_TYPE_RADIO_ENUM,
      property: node.getName(),
      value: value.name,
    });
  };

  const filter = getFilter();

  const isChecked = (filter) => {
    const {selectedFilter} = props;
    return (
      (selectedFilter && selectedFilter.getValue() === filter.getValue()) ||
      false
    );
  };

  const changeOrRemoveFilter = () => {
    const filter = getFilter();
    changeFilter(filter);
  };

  const handleClick = (event) => {
    if (event) {
      event.stopPropagation();
    }
    changeOrRemoveFilter();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      changeOrRemoveFilter();
    }
    return true;
  };

  return (
    <span className={styles.dlFilterNodeTypeRadioItem}>
      <Form.Check
        type={'radio'}
        className={styles.dlFilterNodeTypeRadioItemInput}
        id={`${node.getName()}-${value.label}`}
      >
        <Form.Check.Input
          name={node.getName()}
          ref={inputRef}
          type={'radio'}
          checked={isChecked(filter)}
          value={value.label}
          onChange={handleClick}
          tabIndex={isOpened ? 0 : -1}
          title={value.label}
        />
        <Form.Check.Label>
          <FilterNodeItemLabel label={value.label} />
        </Form.Check.Label>
      </Form.Check>
    </span>
  );
};

FilterNodeTypeRadioItem.displayName = 'FilterNodeTypeRadioItem';
